<template>
	<div :aria-busy="loading ? 'true' : 'false'">
		<section class="content__custom" v-if="!loading">
			<div class="main-title">
				<h1 class="tickets">
					{{ 'tickets' | translate }}
				</h1>
				<h2>{{ 'tickets-subtitle' | translate | capitalize }}</h2>
			</div>
			<div v-if="tickets">
				<div if="tickets.length">
					<nav class="filters">
						<ul>
							<li><a :class="[ filter === '' ? 'active' : '' ]" @click="updateTickets()">{{ $t('all') }}</a></li>
							<li><a :class="[ filter === 'pending' ? 'active' : '' ]" @click="updateTickets('pending')">{{ $t('pending') }}</a></li>
							<li><a :class="[ filter === 'progress' ? 'active' : '' ]" @click="updateTickets('progress')">{{ $t('inProgress') }}</a></li>
							<li><a :class="[ filter === 'closed' ? 'active' : '' ]" @click="updateTickets('closed')">{{ $t('closed') }}</a></li>
						</ul>
					</nav>
					<table class="table-navigation">
						<thead>
							<tr>
								<th>{{ 'ticket' | translate | titleCase }}</th>
								<th>{{ 'date' | translate | titleCase }}</th>
								<th>{{ 'name' | translate | titleCase }}</th>
								<th>{{ 'solicitation' | translate | titleCase }}</th>
								<th>{{ 'status' | translate | titleCase }}</th>
								<th>{{ 'responsible' | translate | titleCase }}</th>
							</tr>
						</thead>

						<tbody>
							<tr
								v-for="ticket in tickets"
								:key="ticket.id"
								v-bind:class="{ 'tr--bold' : ticket.read === 0 }">
								<td :title="'ticket' | translate"><router-link :to="'/chamados/' + (ticket.id)">#{{ ticket.id }}</router-link></td>
								<td :title="'date' | translate"><router-link :to="'/chamados/' + (ticket.id)">{{ ticket.created_at | dateOnly }}</router-link></td>
								<td :title="'name' | translate">
									<router-link :to="'/chamados/' + (ticket.id)">
										{{ (ticket.recipient || {}).name || $t('anonymous') }}
									</router-link>
								</td>
								<td :title="'solicitation' | translate">
									<router-link :to="'/chamados/' + (ticket.id)" class="tickets__tag">
										{{ ticket.type.name }}
									</router-link>
								</td>
								<td
									:title="'status' | translate"
									class="message-cell"
									:class="`status--${ticket.status}`"
								>
									<router-link :to="'/chamados/' + (ticket.id)">
										{{ ticket.status | translate }}
									</router-link>
								</td>
								<td :title="'responsible' | translate" class="message-cell">
									<router-link :to="'/chamados/' + (ticket.id)">
										{{ ((ticket.assignee || {}).name) || 'noResponsible' | translate }}
									</router-link>
								</td>
							</tr>
						</tbody>
					</table>
					<pagination
						:classNames="'pagination-arrows pull-right'"
						dispatchToCall="getTickets"
						:filter="this.filter"
						:itemsPerPageProp="session.results"
						:totalItensPagesProps="totalPages"
						:totalItens="totalItems"
						:totalPagesProp="this.totalPages"
					></pagination>
				</div>
			</div>

			<div v-else>
				<p class="empty-state">
					{{ 'no-message' | translate | capitalize }}
				</p>
			</div>
		</section>
	</div>
</template>

<script>
import pagination from '../../components/pagination/pagination.vue';


export default {
	name: 'tickets',
	data() {
		return {
			loading: false,
			session: {
				page: 1,
				results: 20,
				apiKey:	sessionStorage.getItem('apiKey'),
				userId: sessionStorage.getItem('userId'),
			},
			ticketId: [],
			filter: 'all',
			unreadOnly: false,
		};
	},
	components: {
		pagination,
	},
	computed: {
		user() {
			return this.$store.state.user;
		},
		success() {
			return this.$store.state.status;
		},
		tickets() {
			if (this.unreadOnly) {
				return this.$store.state.tickets.tickets.tickets.filter(ticket => ticket.read === 0);
			}
			return (this.$store.state.tickets.tickets || []).tickets || [];
		},
		itemsOnThisPage() {
			return (this.$store.state.tickets.tickets.tickets || 0).length;
		},
		totalItems() {
			return (this.$store.state.tickets.tickets || 0).itens_count || 0;
		},
		totalPages: {
			get() {
				return this.totalItems / this.session.results || 0;
			},
			set() {
			},
		},
	},
	methods: {
		getTickets() {
			this.toggleLoading();
			const payload = this.session;
			payload.filter = this.filter;
			this.$store.dispatch('getTickets', payload)
				.then(() => {
					this.toggleLoading();
				})
				.catch(() => {
					this.toggleLoading();
				});
		},
		updateTickets(filter) {
			this.filter = filter;
			this.getTickets();
		},
		paginationData() {
			this.tickets = this.tickets;
		},
		toggleLoading() {
			this.loading = !this.loading;
		},
		mySession() {
			const mySession = {};
			mySession.page = this.$route.query.page;
			mySession.results = this.session.results;
			mySession.apiKey = sessionStorage.getItem('apiKey');
			mySession.userId = sessionStorage.getItem('userId');
			this.toggleLoading();
			this.$store.dispatch('getIssues', mySession)
				.then(() => {
					this.toggleLoading();
				})
				.catch(() => {
					this.toggleLoading();
				});
		},
	},
	mounted() {
		this.getTickets();
	},
};
</script>




// WEBPACK FOOTER //
// _source/javascripts/modules/tickets/tickets.vue